// Hook for modal handler operations
import {
  handleCellDetailClick as handleCellDetailClickUtil,
  addNewColumnGlobally as addNewColumnGloballyUtil,
} from "../utils/modalHandlerUtils";
import { useCallback } from "react";

/**
 * Hook for modal handler operations
 */
const useModalHandlers = (gridLineState, modalState, tableState, pdfState) => {
  const { pendingGridLineChanges } = gridLineState;
  const { selectedTable } = tableState;
  const { pdfPageDimensions } = pdfState;

  const handleCellDetailClick = useCallback(
    (rowIndex, colIndex, cellContent, tableData, isAfter = false) => {
      handleCellDetailClickUtil(
        rowIndex,
        colIndex,
        cellContent,
        tableData,
        isAfter,
        {
          pendingGridLineChanges,
          selectedTable,
          pdfPageDimensions,
          modalState,
        }
      );
    },
    [pendingGridLineChanges, selectedTable, pdfPageDimensions, modalState]
  );

  const addNewColumnGlobally = useCallback(
    (newColumnHeader) => {
      addNewColumnGloballyUtil({
        pendingGridLineChanges,
        newColumnHeader,
        gridLineState,
        modalState,
      });
    },
    [pendingGridLineChanges, gridLineState, modalState]
  );

  return {
    handleCellDetailClick,
    addNewColumnGlobally,
  };
};

export default useModalHandlers;
